import { createContext, ReactNode, useCallback, useMemo, useState } from 'react'

import {
  Notification,
  NotificationProps,
} from '~/src/components/shared/Notification/types'

export type NotificationContextType = {
  notifications: Array<Notification>
  isResolvedHidden: boolean
  isDropdownOpen: boolean
  update: (messages: Array<Notification>) => void
  hideResolvedNotifications: () => void
  setIsDropdownOpen: (isOpen: boolean) => void
}

export const NotificationContext = createContext<NotificationContextType | null>(null)

export const NotificationContextProvider = ({ children }: { children: ReactNode }) => {
  const [isResolvedHidden, setIsResolvedHidden] = useState(false)
  const [notifications, setNotifications] = useState<Array<NotificationProps>>([])
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const hideResolvedNotifications = useCallback(() => {
    setIsResolvedHidden((prev) => !prev)
  }, [])

  const value: NotificationContextType = useMemo(
    () => ({
      notifications,
      isDropdownOpen,
      isResolvedHidden,
      setIsDropdownOpen,
      hideResolvedNotifications,
      update: setNotifications,
    }),
    [
      isResolvedHidden,
      notifications,
      isDropdownOpen,
      setNotifications,
      setIsDropdownOpen,
      hideResolvedNotifications,
    ]
  )

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  )
}
